import "./styles.scss";

import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const CardTeacher = ({ ratingPendingAVG }) => {
  const { t } = useTranslation();
  const { allClasses } = useSelector((state) => state.genericReducer);

  return (
    <div className="countersInfo">
      <div className="todayClasses">
        <span className="titleInfo">{t("CLASSES_TODAY")}</span>
        <span className="counterInfo">
          {
            allClasses.filter((cl) => moment().format("YYYY-MM-DD") === moment(cl.scheduledDate).format("YYYY-MM-DD"))
              .length
          }{" "}
          {allClasses.filter((cl) => moment().format("YYYY-MM-DD") === moment(cl.scheduledDate).format("YYYY-MM-DD"))
            .length < 2
            ? t("CLASS")
            : t("CLASSES")}
        </span>
      </div>
      {ratingPendingAVG > 0 && (
        <div className="ratingCounter">
          <span className="titleInfo">{t("RATING_AVG_INFO")}</span>
          <span className="counterInfo">{ratingPendingAVG}</span>
        </div>
      )}
    </div>
  );
};

export default CardTeacher;
